namespace TabAurous.Retail {
    export namespace OrderStatusService {
        export const baseUrl = 'Retail/OrderStatus';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<POSOrderItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Retail/OrderStatus/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>OrderStatusService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
